document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-menu-toggle]');
  const nav = document.querySelector('[data-mobile-nav]');

  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const isOpen = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
    });
  }

  document.querySelectorAll('[data-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const form = select.closest('form');
      const price = form?.querySelector('[data-product-price]');
      const option = select.options[select.selectedIndex];
      if (price && option?.dataset.price) price.textContent = option.dataset.price;
    });
  });


  document.querySelectorAll('[data-hero-carousel]').forEach((carousel) => {
    const slides = Array.from(carousel.querySelectorAll('[data-hero-slide]'));
    const dots = Array.from(carousel.querySelectorAll('[data-hero-dot]'));
    const prev = carousel.querySelector('[data-hero-prev]');
    const next = carousel.querySelector('[data-hero-next]');
    if (slides.length < 2) return;

    let index = 0;
    let timer;
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    const show = (nextIndex) => {
      index = (nextIndex + slides.length) % slides.length;
      slides.forEach((slide, slideIndex) => {
        const active = slideIndex === index;
        slide.classList.toggle('is-active', active);
        slide.setAttribute('aria-hidden', String(!active));
        slide.querySelectorAll('a').forEach((link) => link.tabIndex = active ? 0 : -1);
      });
      dots.forEach((dot, dotIndex) => {
        const active = dotIndex === index;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-selected', String(active));
      });
    };

    const stop = () => { if (timer) window.clearInterval(timer); timer = undefined; };
    const start = () => {
      if (!reducedMotion && !timer) timer = window.setInterval(() => show(index + 1), 6000);
    };

    prev?.addEventListener('click', () => { show(index - 1); stop(); });
    next?.addEventListener('click', () => { show(index + 1); stop(); });
    dots.forEach((dot, dotIndex) => dot.addEventListener('click', () => { show(dotIndex); stop(); }));
    carousel.addEventListener('mouseenter', stop);
    carousel.addEventListener('focusin', stop);
    carousel.addEventListener('mouseleave', start);
    carousel.addEventListener('focusout', (event) => { if (!carousel.contains(event.relatedTarget)) start(); });
    start();
  });

});
